export default __webpack_public_path__ + "static/media/image2.08d9ce06.png";